import { NgModule } from '@angular/core';


import { CommonModule } from '@angular/common';
import { CookieInfoComponent } from './cookie.info.component';
import { UiPartsModule } from '@ui-parts';
import { NotificationModule } from '@notification';
import { CookieInfoOutsideComponent } from './cookie.info.outside.component';

@NgModule({
    imports: [
        CommonModule,
        UiPartsModule,
        NotificationModule
    ],
    declarations: [
        CookieInfoOutsideComponent,
        CookieInfoComponent
    ],
    exports: [
        CookieInfoOutsideComponent,
        CookieInfoComponent
    ],
    providers: [

    ]
})
export class CookieModule {
}

export {
    CookieInfoOutsideComponent,
    CookieInfoComponent
};
